import useFeatureFlag from '../../common/use-feature-flag';
import { Feature } from '../../models/features/features';
import { UserHomepage } from './custom-homepage';
import OldHome from './old';

const Home = () => {
  const customHomepageEnabled = useFeatureFlag(Feature.CUSTOM_HOMEPAGE_ENABLED);
  if (!customHomepageEnabled) {
    return <OldHome />;
  }
  return <UserHomepage />;
};

export default Home;
